import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";

export default function PermissionsManagementPage() {
    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();
    const [permissions, setPermissions] = useState([]);
    const [filteredPermissions, setFilteredPermissions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterType, setFilterType] = useState("all");

    //  جلب الصلاحيات من السيرفر
    const fetchPermissions = async () => {
        try {
            const res = await backEnd_request.get("/admin/Permissions");
            setPermissions(res.data.permissions || res.data);
            setFilteredPermissions(res.data.permissions || res.data);
            console.log(res.data)
        } catch (error) {
            console.log(error.response?.data || error);
        }
    };

    useEffect(() => {
        fetchPermissions();
    }, []);

    // 🔍 تصفية حسب الاسم أو الفئة أو الاسم الظاهر
    const handleSearch = (term, type) => {
        setSearchTerm(term);
        setFilterType(type);

        let filtered = permissions.filter((perm) => {
            if (!term.trim()) return true;
            switch (type) {
                case "name":
                    return perm.name?.toLowerCase().includes(term.toLowerCase());
                case "displayName":
                    return perm.displayName?.toLowerCase().includes(term.toLowerCase());
                case "category":
                    return perm.category?.toLowerCase().includes(term.toLowerCase());
                default:
                    return (
                        perm.name?.toLowerCase().includes(term.toLowerCase()) ||
                        perm.displayName?.toLowerCase().includes(term.toLowerCase()) ||
                        perm.category?.toLowerCase().includes(term.toLowerCase())
                    );
            }
        });
        setFilteredPermissions(filtered);
    };

    //  حذف صلاحية
    const handleDelete = async (permissionId) => {
        if (window.confirm("هل أنت متأكد من حذف هذه الصلاحية؟")) {
            try {
                await backEnd_request.delete(`/admin/Permissions/${permissionId}`);
                fetchPermissions();
                setDeleteSuccessMessage("تم حذف الصلاحية بنجاح ✅");
                setTimeout(() => setDeleteSuccessMessage(""), 3000);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };

    return (
        <div className="container py-5">
            {/* العنوان + زر الإضافة */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">إدارة الصلاحيات</h3>
                <button
                    className="btn btn-success"
                    onClick={() => navigate("/admin/permissions-management/create")}
                >
                    <i className="bi bi-plus-circle"></i> إضافة صلاحية
                </button>
            </div>

            {/* رسائل النجاح */}
            {successMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {successMessage}
                </div>
            )}
            {deleteSuccessMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {deleteSuccessMessage}
                </div>
            )}

            {/* أدوات البحث */}
            <div className="card shadow-sm mb-4 p-3">
                <div className="row g-3 align-items-center">
                    <div className="col-md-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="اكتب هنا للبحث..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value, filterType)}
                        />
                    </div>
                    <div className="col-md-3">
                        <select
                            className="form-select"
                            value={filterType}
                            onChange={(e) => handleSearch(searchTerm, e.target.value)}
                        >
                            <option value="all">كل الحقول</option>
                            <option value="name">الاسم</option>
                            <option value="displayName">الاسم الظاهر</option>
                            <option value="category">الفئة</option>
                        </select>
                    </div>
                    <div className="col-md-2">
                        <button
                            className="btn btn-outline-secondary w-100"
                            onClick={() => {
                                setSearchTerm("");
                                setFilteredPermissions(permissions);
                            }}
                        >
                            إعادة تعيين
                        </button>
                    </div>
                </div>
            </div>

            {/* الجدول */}
            <div className="table-responsive shadow-sm">
                <table className="table table-hover align-middle text-center">
                    <thead className="table-primary">
                        <tr>
                            <th>الاسم</th>
                            <th>الاسم الظاهر</th>
                            <th>الوصف</th>
                            <th>الفئة</th>
                            <th>نظامية؟</th>
                            <th>إجراءات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredPermissions.length > 0 ? (
                            filteredPermissions.map((perm) => (
                                <tr key={perm.permissionId}>
                                    <td>{perm.name}</td>
                                    <td>{perm.displayName}</td>
                                    <td>{perm.description || "-"}</td>
                                    <td>{perm.category || "-"}</td>
                                    <td>
                                        <span
                                            className={`badge ${perm.isSystemPermission
                                                    ? "bg-warning text-dark"
                                                    : "bg-success"
                                                }`}
                                        >
                                            {perm.isSystemPermission ? "نظامية" : "عادية"}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() =>
                                                handleDelete(perm.permissionId)
                                            }
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-muted py-4">
                                    لا توجد بيانات لعرضها
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
